<template>
  <b-card>
    <!-- form -->
    <b-form @submit.prevent="handleSubmit">
      <b-row>
        <!-- old password -->
        <b-col md="6">
          <b-form-group
            :label="$t('accountSettings.changePassword.currentPassword')"
            label-for="account-old-password"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="account-old-password"
                v-model="passwordValueOld"
                name="current_password"
                :type="passwordFieldTypeOld"
                :placeholder="$t('accountSettings.changePassword.currentPassword')"
                :state="getFieldState('current_password')"
                required
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIconOld"
                  class="cursor-pointer"
                  @click="togglePasswordOld"
                />
              </b-input-group-append>
            </b-input-group>
            <b-form-invalid-feedback v-if="errors.current_password">
              {{ errors.current_password[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <!--/ old password -->
      </b-row>
      <b-row>
        <!-- new password -->
        <b-col md="6">
          <b-form-group
            label-for="account-new-password"
            :label="$t('accountSettings.changePassword.newPassword')"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="account-new-password"
                v-model="newPasswordValue"
                :type="passwordFieldTypeNew"
                name="password"
                :placeholder="$t('accountSettings.changePassword.newPassword')"
                minlength="8"
                :state="getFieldState('password')"
                required
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIconNew"
                  class="cursor-pointer"
                  @click="togglePasswordNew"
                />
              </b-input-group-append>
            </b-input-group>
            <b-form-invalid-feedback v-if="errors.password">
              {{ errors.password[0] }}
            </b-form-invalid-feedback>
            <small class="text-muted">{{ $t('accountSettings.changePassword.minLength') }}</small>
          </b-form-group>
        </b-col>
        <!--/ new password -->

        <!-- retype password -->
        <b-col md="6">
          <b-form-group
            label-for="account-retype-new-password"
            :label="$t('accountSettings.changePassword.confirmPassword')"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="account-retype-new-password"
                v-model="RetypePassword"
                :type="passwordFieldTypeRetype"
                name="password_confirmation"
                :placeholder="$t('accountSettings.changePassword.confirmPassword')"
                :state="passwordMatchState"
                required
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIconRetype"
                  class="cursor-pointer"
                  @click="togglePasswordRetype"
                />
              </b-input-group-append>
            </b-input-group>
            <b-form-invalid-feedback v-if="!passwordsMatch && RetypePassword">
              {{ $t('accountSettings.changePassword.passwordsDoNotMatch') }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <!--/ retype password -->

        <!-- buttons -->
        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            type="submit"
            class="mt-1 mr-1"
            :disabled="loading || !passwordsMatch"
          >
            <b-spinner v-if="loading" small class="mr-50" />
            {{ loading ? $t('accountSettings.changePassword.changing') : $t('accountSettings.changePassword.changePassword') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="outline-secondary"
            class="mt-1"
            :disabled="loading"
            @click="resetForm"
          >
            {{ $t('accountSettings.changePassword.reset') }}
          </b-button>
        </b-col>
        <!--/ buttons -->
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BInputGroup, BInputGroupAppend, BFormInvalidFeedback, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
    BFormInvalidFeedback,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      passwordValueOld: '',
      newPasswordValue: '',
      RetypePassword: '',
      passwordFieldTypeOld: 'password',
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
      errors: {},
      loading: false,
    }
  },
  computed: {
    passwordToggleIconOld() {
      return this.passwordFieldTypeOld === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordsMatch() {
      if (!this.newPasswordValue || !this.RetypePassword) {
        return true
      }
      return this.newPasswordValue === this.RetypePassword
    },
    passwordMatchState() {
      if (!this.RetypePassword) {
        return null
      }
      return this.passwordsMatch ? true : false
    },
  },
  methods: {
    togglePasswordOld() {
      this.passwordFieldTypeOld = this.passwordFieldTypeOld === 'password' ? 'text' : 'password'
    },
    togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype = this.passwordFieldTypeRetype === 'password' ? 'text' : 'password'
    },
    getFieldState(fieldName) {
      if (this.errors[fieldName]) {
        return false
      }
      return null
    },
    resetForm() {
      this.passwordValueOld = ''
      this.newPasswordValue = ''
      this.RetypePassword = ''
      this.errors = {}
    },
    async handleSubmit() {
      if (!this.passwordsMatch) {
        this.showToast('danger', this.$t('Error'), this.$t('accountSettings.messages.passwordMatchError'))
        return
      }

      if (this.newPasswordValue.length < 8) {
        this.showToast('danger', this.$t('Error'), this.$t('accountSettings.messages.passwordLengthError'))
        return
      }

      this.loading = true
      this.errors = {}

      try {
        const response = await this.$http.post(
          '/dashboard/v1/merchants/change-password',
          {
            current_password: this.passwordValueOld,
            password: this.newPasswordValue,
            password_confirmation: this.RetypePassword,
          },
        )

        this.showToast('success', this.$t('message.operation_success'), response.data.message || this.$t('accountSettings.messages.passwordChanged'))
        this.resetForm()
      } catch (error) {
        if (error.response) {
          if (error.response.status === 422 && error.response.data.errors) {
            this.errors = error.response.data.errors
            this.showToast('danger', this.$t('message.generic_validation_error'), this.$t('accountSettings.messages.validationError'))
          } else if (error.response.status === 401) {
            this.showToast('danger', this.$t('errors.not_authorized.title'), this.$t('accountSettings.messages.unauthorized'))
          } else {
            this.showToast('danger', this.$t('Error'), error.response.data.message || this.$t('accountSettings.messages.updateError'))
          }
        } else {
          this.showToast('danger', this.$t('Error'), this.$t('accountSettings.messages.networkError'))
        }
      } finally {
        this.loading = false
      }
    },
    showToast(variant, title, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon: variant === 'success' ? 'CheckIcon' : 'AlertCircleIcon',
          variant,
          text,
        },
      })
    },
  },
}
</script>
